import { useTheme } from '@mui/material';
import { SVGProps } from 'react';

import { PortalTheme } from '../../theme';

export const QrIcon = (props: SVGProps<SVGSVGElement>) => {
  const theme = useTheme<PortalTheme>();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={44}
      height={44}
      fill="none"
      {...props}
    >
      <path
        fill={theme.card.contrastText}
        fillRule="evenodd"
        d="M8.848 16.022V8.848h7.174v7.174H8.848Zm0 19.13v-7.174h7.174v7.174H8.848Zm19.13-19.13V8.848h7.174v7.174h-7.174ZM8.37 6.457A1.913 1.913 0 0 0 6.457 8.37v8.13c0 1.057.856 1.913 1.913 1.913h8.13a1.913 1.913 0 0 0 1.913-1.913V8.37A1.913 1.913 0 0 0 16.5 6.457H8.37Zm0 19.13A1.913 1.913 0 0 0 6.457 27.5v8.13c0 1.057.856 1.914 1.913 1.914h8.13a1.913 1.913 0 0 0 1.913-1.913V27.5a1.913 1.913 0 0 0-1.913-1.914H8.37ZM25.587 8.37c0-1.057.857-1.913 1.913-1.913h8.13c1.057 0 1.914.856 1.914 1.913v8.13a1.913 1.913 0 0 1-1.913 1.913H27.5a1.913 1.913 0 0 1-1.914-1.913V8.37ZM8.848 20.805H6.457v2.391h2.391v-2.391Zm2.391 0h2.392v2.391h-2.392v-2.391Zm7.174 0h-2.391v2.391h2.391v-2.391Zm2.392 0h4.782v2.391h-2.391V27.98h-2.391V20.805Zm7.174 0h2.39v2.391h-2.39v-2.391Zm4.782 4.782v-2.39H30.37v2.39h-4.782V30.37H20.804v2.391h4.782v-2.39h2.392v2.39h4.782v2.392h2.391v2.391h2.392v-2.391h-2.392V30.37h2.392v-2.392h-2.392v-2.392h2.392v-4.782h-2.392v4.782h-2.39Zm0 0H30.37v2.392h-2.392v2.391H32.761V25.587Zm-11.956 9.566h2.39v2.391h-2.39v-2.391Zm7.174 0h-2.392v2.391h4.782v-2.391h-2.39Zm-7.174-16.74V11.24h2.39V18.414h-2.39Zm2.39-11.956h-2.39v2.391h2.39V6.457Z"
        clipRule="evenodd"
      />
      <path
        fill={theme.card.secondaryContrastText}
        fillRule="evenodd"
        d="M0 5.022A5.022 5.022 0 0 1 5.022 0h6.337a1.196 1.196 0 1 1 0 2.392H5.022a2.63 2.63 0 0 0-2.63 2.63v6.337a1.196 1.196 0 1 1-2.392 0V5.022Zm38.978-2.63h-6.337a1.196 1.196 0 0 1 0-2.392h6.337A5.022 5.022 0 0 1 44 5.022v6.337a1.196 1.196 0 1 1-2.391 0V5.022a2.63 2.63 0 0 0-2.63-2.63ZM1.196 31.446c.66 0 1.195.535 1.195 1.195v6.337a2.63 2.63 0 0 0 2.63 2.63h6.338a1.196 1.196 0 0 1 0 2.392H5.022A5.022 5.022 0 0 1 0 38.978v-6.337c0-.66.535-1.195 1.196-1.195Zm40.413 7.532v-6.337a1.196 1.196 0 0 1 2.391 0v6.337A5.022 5.022 0 0 1 38.978 44h-6.337a1.196 1.196 0 0 1 0-2.391h6.337a2.63 2.63 0 0 0 2.63-2.63Z"
        clipRule="evenodd"
        opacity={0.15}
      />
    </svg>
  );
};
